import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CartDrawer from "./CartDrawer";
import FloatingActions from "./FloatingActions";
import { Toaster } from "@/components/ui/sonner";

const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-beige paper-texture">
      <Navbar />
      <main className="flex-1 pt-24">
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
      <FloatingActions />
      <Toaster
        position="bottom-right"
        toastOptions={{
          className: "!bg-beige-light !border-gold/30 !text-ink !font-sans",
        }}
      />
    </div>
  );
};

export default Layout;
